import createEditManageWorkOrderStatus from '../modals/createEditManageWorkOrderStatus/lan/en';
import deleteManageWorkOrderStatus from '../modals/deleteManageWorkOrderStatus/lan/en';

export default {
    manage_workOrderStatus_name: "Name",
    manage_workOrderStatus_color: "Color",
    manage_workOrderStatus_description: "Description",
    manage_workOrderStatus_category: "Category",
    manage_workOrderStatus_default: "Default",
    manage_workOrderStatus_search_by_name_description: "Search by Name or Description",
    ...createEditManageWorkOrderStatus,
    ...deleteManageWorkOrderStatus,
}